// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SchoolRequestsPage_container__Z\\+daI {
  background-color: #f8f9fa;
  min-height: 100vh;
}

.SchoolRequestsPage_cardHover__wgg\\+u {
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.SchoolRequestsPage_cardHover__wgg\\+u:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1) !important;
}

.SchoolRequestsPage_card__\\+bmUJ {
  border-radius: 12px;
  background: #ffffff;
  border: 1px solid #e0e0e0;
}

.SchoolRequestsPage_cardBody__ptLMw {
  padding: 1.5rem;
}

.SchoolRequestsPage_header__DWXxC {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
}

.SchoolRequestsPage_cardTitle__8UMxn {
  font-size: 1.25rem;
  font-weight: 600;
  margin-bottom: 0;
}

.SchoolRequestsPage_statusBadge__bkfxa {
  font-size: 0.75rem;
  font-weight: 500;
  padding: 0.25rem 0.5rem;
  border-radius: 12px;
}

.SchoolRequestsPage_statusAccepted__cdX24 {
  color: #28a745;
  background-color: #e6f4ea;
}

.SchoolRequestsPage_statusNotAccepted__nhyvE {
  color: #dc3545;
  background-color: #f8d7da;
}

.SchoolRequestsPage_statusNotPulled__A334l {
  color: #ffc107;
  background-color: #fff3cd;
}

.SchoolRequestsPage_cardText__ezWOV {
  font-size: 0.875rem;
  color: #495057;
  line-height: 1.5;
}

.SchoolRequestsPage_detail__7Cfej {
  display: flex;
  justify-content: space-between;
  margin-bottom: 0.5rem;
}

.SchoolRequestsPage_label__CJMKN {
  font-weight: 500;
  color: #6c757d;
  flex: 0 0 40%;
}

.SchoolRequestsPage_btnPrimary__0mc1X {
  background-color: #007bff;
  border-color: #007bff;
  border-radius: 5px;
  padding: 0.5rem 1.25rem;
  font-size: 0.875rem;
  font-weight: 500;
  width: 100%;
  transition: background-color 0.3s ease;
}

.SchoolRequestsPage_btnPrimary__0mc1X:hover {
  background-color: #0056b3;
  border-color: #0056b3;
}

.SchoolRequestsPage_h1__CxVRv {
  font-size: 2rem;
  font-weight: 700;
  color: #343a40;
}
.SchoolRequestsPage_email_container__VcNb8 {
  max-width: 200px; /* Adjust based on your design */
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}


.SchoolRequestsPage_statusPending__GjV9f {
  color: #856404;
  background-color: #fff3cd;
}

.SchoolRequestsPage_statusRejected__bklRb {
  color: #dc3545;
  background-color: #f8d7da;
}

.SchoolRequestsPage_statusAccepted__cdX24 {
  color: #28a745;
  background-color: #e6f4ea;
}

.SchoolRequestsPage_statusNotPulled__A334l {
  color: #ffc107;
  background-color: #fff3cd;
}`, "",{"version":3,"sources":["webpack://./src/pages/dashboard/schooldashboard/SchoolRequestsPage/SchoolRequestsPage.module.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,2BAA2B;EAC3B,oDAAoD;AACtD;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;EACX,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,gBAAgB,EAAE,gCAAgC;EAClD,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;;AAGA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B","sourcesContent":[".container {\n  background-color: #f8f9fa;\n  min-height: 100vh;\n}\n\n.cardHover {\n  transition: transform 0.3s ease, box-shadow 0.3s ease;\n}\n\n.cardHover:hover {\n  transform: translateY(-5px);\n  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1) !important;\n}\n\n.card {\n  border-radius: 12px;\n  background: #ffffff;\n  border: 1px solid #e0e0e0;\n}\n\n.cardBody {\n  padding: 1.5rem;\n}\n\n.header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 1rem;\n}\n\n.cardTitle {\n  font-size: 1.25rem;\n  font-weight: 600;\n  margin-bottom: 0;\n}\n\n.statusBadge {\n  font-size: 0.75rem;\n  font-weight: 500;\n  padding: 0.25rem 0.5rem;\n  border-radius: 12px;\n}\n\n.statusAccepted {\n  color: #28a745;\n  background-color: #e6f4ea;\n}\n\n.statusNotAccepted {\n  color: #dc3545;\n  background-color: #f8d7da;\n}\n\n.statusNotPulled {\n  color: #ffc107;\n  background-color: #fff3cd;\n}\n\n.cardText {\n  font-size: 0.875rem;\n  color: #495057;\n  line-height: 1.5;\n}\n\n.detail {\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 0.5rem;\n}\n\n.label {\n  font-weight: 500;\n  color: #6c757d;\n  flex: 0 0 40%;\n}\n\n.btnPrimary {\n  background-color: #007bff;\n  border-color: #007bff;\n  border-radius: 5px;\n  padding: 0.5rem 1.25rem;\n  font-size: 0.875rem;\n  font-weight: 500;\n  width: 100%;\n  transition: background-color 0.3s ease;\n}\n\n.btnPrimary:hover {\n  background-color: #0056b3;\n  border-color: #0056b3;\n}\n\n.h1 {\n  font-size: 2rem;\n  font-weight: 700;\n  color: #343a40;\n}\n.email_container {\n  max-width: 200px; /* Adjust based on your design */\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n\n.statusPending {\n  color: #856404;\n  background-color: #fff3cd;\n}\n\n.statusRejected {\n  color: #dc3545;\n  background-color: #f8d7da;\n}\n\n.statusAccepted {\n  color: #28a745;\n  background-color: #e6f4ea;\n}\n\n.statusNotPulled {\n  color: #ffc107;\n  background-color: #fff3cd;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `SchoolRequestsPage_container__Z+daI`,
	"cardHover": `SchoolRequestsPage_cardHover__wgg+u`,
	"card": `SchoolRequestsPage_card__+bmUJ`,
	"cardBody": `SchoolRequestsPage_cardBody__ptLMw`,
	"header": `SchoolRequestsPage_header__DWXxC`,
	"cardTitle": `SchoolRequestsPage_cardTitle__8UMxn`,
	"statusBadge": `SchoolRequestsPage_statusBadge__bkfxa`,
	"statusAccepted": `SchoolRequestsPage_statusAccepted__cdX24`,
	"statusNotAccepted": `SchoolRequestsPage_statusNotAccepted__nhyvE`,
	"statusNotPulled": `SchoolRequestsPage_statusNotPulled__A334l`,
	"cardText": `SchoolRequestsPage_cardText__ezWOV`,
	"detail": `SchoolRequestsPage_detail__7Cfej`,
	"label": `SchoolRequestsPage_label__CJMKN`,
	"btnPrimary": `SchoolRequestsPage_btnPrimary__0mc1X`,
	"h1": `SchoolRequestsPage_h1__CxVRv`,
	"email_container": `SchoolRequestsPage_email_container__VcNb8`,
	"statusPending": `SchoolRequestsPage_statusPending__GjV9f`,
	"statusRejected": `SchoolRequestsPage_statusRejected__bklRb`
};
export default ___CSS_LOADER_EXPORT___;
